<template>
  <v-container fill-height pa-0 ma-0 fluid class="search-active">
    <filters 
      :show="showFilters"
      :tab="activeSubTab"
      :filters="customFilters"
      @close="closeFiltersDrawer"
      @filter="filterChats"></filters>
    <v-layout row wrap>
      <v-flex md3 class="position-relative white">
        <v-layout row wrap class="no-fill-height" :class="{ blured: disconected && user.role === 'agent' }">
          <v-flex xs-12 class="d-flex justify-evenly mt-3 mb-3">
            <div class="text-xs-center separator--right">
              <div class="d-inline text-xs-center">
                <v-btn flat icon small
                class="position-relative"
                @click="showFilters = true">
                  <v-icon class="p-absolute filter-active" v-show="filters.minDate || filters.maxDate || filters.solvedBy">fas fa-circle</v-icon>
                  <v-tooltip bottom>
                    <v-icon small slot="activator" :class="{ 'k-orange-linear-text': filters.minDate || filters.maxDate || filters.solvedBy, 'blue-grey--text text--darken-4': !(filters.minDate || filters.maxDate || filters.solvedBy) }">fas fa-filter</v-icon>
                    <span>Mas filtros</span>
                  </v-tooltip>
                </v-btn>
              </div>
              <div class="d-inline text-xs-center">
                <v-btn
                flat
                icon
                small
                :class="{ 'k-orange-linear-text': this.search !== '' }"
                @click="toggleSearchField">
                  <v-tooltip bottom>
                    <v-icon small slot="activator">fas fa-search</v-icon>
                    <span>Buscar por nombre, cuenta o RUT</span>
                  </v-tooltip>
                </v-btn>
              </div>
            </div>
            <div class="text-xs-center" v-for="(channel, index) in channels" :key="`filter-btn-${index}`">
              <v-btn 
                flat
                icon
                small 
                :disabled="channel.value === 'chatbot' && activeTab === '1'"
                @click="toggleChannelFilter(index)">
                <v-tooltip bottom>
                  <v-icon small slot="activator" :key="`filter-icon-${index}`" :class="{ 'k-orange-linear-text': channel.active, 'blue-grey--text text--darken-4': !channel.active }">{{ channel.icon }}</v-icon>
                  <span>{{ channel.title }}</span>
                </v-tooltip>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="no-fill-height" :class="{ blured: disconected && user.role === 'agent' }">
          <v-flex xs12 class="collapse-wrapper" :class="{ collapsed: !showSearch }">
            <v-text-field
              v-model="search"
              color="gray"
              class="chat-search elevation-0 mt-0"
              label="Busqueda:"
              flat
              solo
              :disabled="!showSearch"
              @keypress.enter="showSearch = false">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="no-fill-height" :class="{ blured: disconected && user.role === 'agent' }">
          <v-flex xs12>
            <v-tabs
              v-model="activeTab"
              slider-color="k-orange-linear"
              :right="true"
              :class="{ 'no-tabs': user.role === 'agent' }"
              grow>
              <v-tab
                v-for="(tab, i) in tabs"
                ripple
                active-class="v-tabs__item--active tab-is-active"
                :key="`tab-${i}`">
                {{ tab.title }}
              </v-tab>
              <v-tab-item
                v-for="(tab, i) in tabs"
                :key="`chat-tab-${i}`">
                <v-tabs
                  v-model="activeSubTab"
                  slider-color="k-orange-linear"
                  grow
                  color="white"
                  :right="true"
                  :class="{ blured: disconected && user.role === 'admin' && activeTab === '1' }">
                  <v-tab
                    v-for="(subtab, i) in subtabs"
                    ripple
                    :key="`subtab-${i}`">
                    <v-badge right v-model="subtab.show" color="k-orange-linear tab-badge">
                      <span slot="badge" class="small">{{ subtab.total }}</span>
                      {{ subtab.title }}
                    </v-badge>
                  </v-tab>
                  <v-tab-item
                    v-for="(subtab, j) in subtabs"
                    :key="`chat-tab-list-${j}`"
                    :class="{ blured: disconected && user.role === 'admin' && activeTab === '1' }">
                    <chats-list
                      ref="chatsList"
                      :tab="i"
                      :subtab="j"
                      :chats="sortedChats"
                      :limit="limit"
                      :show-search="showSearch"
                      :active-tab="activeTab"
                      :active-chat="activeChat"
                      :active-sub-tab="activeSubTab"
                      @reasign="reasign"
                      @open-chat="openChat"
                      @search-chats="fetchChats(true)">
                    </chats-list>
                  </v-tab-item>
                </v-tabs>
                <connect-panel v-if="disconected && activeTab === '1'"
                    @complete="init">
                </connect-panel>
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-layout>
        <connect-panel v-if="disconected && user.role === 'agent'"
          @complete="init">

        </connect-panel>
      </v-flex>
      <v-flex md9>
        <transition-group name="fade">
          <v-layout row wrap v-show="Object.keys(activeChat).length" key="chat-room">
            <v-flex md8>
              <v-layout row wrap class="h-auto">
                <v-flex xs12>
                  <v-btn
                    :class="{'ma-0 w-100': true, 'k-orange-linear': activeChat.status !== 'Resuelto', 'k-blue-linear': activeChat.status === 'Resuelto'}"
                    id="solved-button"
                    @click="solve()"
                    :disabled="activeChat.status === 'Equivocado' || activeChat.channel === 'chatbot'">
                    <template v-if="activeChat.status !== 'Resuelto'">
                      Marcar como resuelto
                    </template>
                    <template v-else>
                      Marcar como no resuelto
                    </template>
                  </v-btn>
                </v-flex>
              </v-layout>
              <chat-room 
                v-if="Object.keys(activeChat).length" key="chat-room"
                :chat="activeChat" 
                :active-tab="1"
                @updateSendedMessage="updateSendedMessage"
                @appendMessagesToChat="transformMessageToAppend"
                @updateActiveChat="transformChatToAppend"></chat-room>
            </v-flex>
            <v-flex md4 class="white">
              <customer-detail 
                :chat="activeChat"
                @close-chat="closeChat"></customer-detail>
              <notification-schedule-detail :action-buttons="false">
                
              </notification-schedule-detail>

              <confirm-dialog @statusChanged="unsolve"></confirm-dialog>
              <assign-dialog></assign-dialog>
              <customer-movements></customer-movements>
              <customer-detail-dialog></customer-detail-dialog>
              <answer-templates></answer-templates>
              <solved-dialog
                @mark-solved="markSolved"></solved-dialog>
              <reasign-operator-dialog 
                :show="showReasignChatDialog"
                :selected-chat="selectedChat"
                @close="closeReasign">
              </reasign-operator-dialog>
            </v-flex>
          </v-layout>
          <v-flex md12 v-show="Object.keys(activeChat).length === 0" key="chat-reports">
            <chat-center-report />
          </v-flex>
        </transition-group>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import _ from 'lodash';
  import Vue from 'vue';
  import moment from 'moment';
  import Filters from '@/components/chat_center/Filters';
  import EventBus from '@/event-bus';
  import ChatRoom from '@/components/chat_center/ChatRoom';
  import ChatsList from '@/components/chat_center/ChatsList';
  import AssignDialog from '@/components/chat_center/AssignDialog';
  import ConnectPanel from '@/components/chat_center/ConnectPanel';
  import SolvedDialog from '@/components/chat_center/SolvedDialog';
  import ConfirmDialog from '@/components/chat_center/ConfirmDialog';
  import CustomerDetail from '@/components/chat_center/CustomerDetail';
  import AnswerTemplates from '@/components/chat_center/AnswerTemplates';
  import ChatCenterReport from '@/components/reports/chat_center/Chats';
  import CustomerMovements from '@/components/chat_center/CustomerMovements';
  import CustomerDetailDialog from '@/components/chat_center/CustomerDetailDialog';
  import ReasignOperatorDialog from '@/components/chat_center/ReasignOperatorDialog';
  import NotificationScheduleDetail from '@/components/notification_schedule/Detail';

  const qs = require('qs');

  export default {
    mounted() {
      const { channels } = (this.userFilters || {});
      if (channels) {
        this.channels.forEach((x) => {
          // eslint-disable-next-line
          x.active = channels.includes(x.value);
        });
      }
      if (this.user.chat_center_online === 1 || this.user.chat_center_online === true || (this.activeTab === '0' && this.user.role === 'admin')) {
        this.listenEvents = true;
        this.fetchChats();
        this.fetchTotals();
      }
      EventBus.$emit('hideMenu');
    },
    components: {
      Filters,
      ChatRoom,
      ChatsList,
      AssignDialog,
      ConnectPanel,
      SolvedDialog,
      ConfirmDialog,
      CustomerDetail,
      AnswerTemplates,
      ChatCenterReport,
      CustomerMovements,
      CustomerDetailDialog,
      ReasignOperatorDialog,
      NotificationScheduleDetail,
    },
    data() {
      return {
        chats: [],
        limit: 10,
        offset: 0,
        search: '',
        totals: [],
        showBtn: false,
        channels: [
          {
            title: 'Whatsapp',
            value: 'whatsapp',
            icon: 'fab fa-whatsapp',
            active: true,
          },
          {
            title: 'Email',
            value: 'email',
            icon: 'fas fa-envelope',
            active: true,
          },
          {
            title: 'Sms',
            value: 'sms',
            icon: 'fas fa-comment',
            active: true,
          },
          {
            title: 'Chatbot',
            value: 'chatbot',
            icon: 'fas fa-robot',
            active: false,
          },
        ],
        activeTab: '0',
        showSearch: false,
        isSearching: false,
        searchChats: true,
        cancelToken: this.axios.CancelToken.source(),
        showFilters: false,
        activeChatId: -1,
        selectedChat: -1,
        activeSubTab: '0',
        listenEvents: false,
        activeChatTab: -1,
        stopScrolling: false,
        customFilters: {
        },
        showReasignChatDialog: false,
      };
    },
    computed: {
      userFilters() {
        return JSON.parse(this.user.chat_center_filters);
      },
      user() {
        return this.$auth.user();
      },
      url() {
        let url = `chats_center?${qs.stringify(this.filters)}&`;
        url += `limit=${this.limit}&`;
        url += `offset=${this.offset}`;
        return url;
      },
      totalUrl() {
        return `chats_center/totals?${qs.stringify(this.filters)}`;
      },
      filters() {
        const filters = {
          // eslint-disable-next-line
          channels: this.channels.length > 0 ? this.channels.filter(item => item.active === true).map(item => item.value) : [],
        };
        if (Object.keys(this.tabFilter).length > 0) {
          filters.my_chats = true;
        }
        if (this.subTabFilter.status) {
          filters.status = this.subTabFilter.status;
        }
        if (this.search !== '') {
          filters.search = this.search;
        }
        if (this.customFilters.minDate) {
          filters.minDate = this.customFilters.minDate;
        }
        if (this.customFilters.maxDate) {
          filters.maxDate = this.customFilters.maxDate;
        }
        if (this.customFilters.solvedBy) {
          filters.solvedBy = this.customFilters.solvedBy;
        }
        return filters;
      },
      channel() {
        return `company.${this.$auth.user().company.id}.chatCenter`;
      },
      tabs() {
        if (this.user.role === 'agent') {
          return [
            {
              title: 'Mios',
              filters: {
                mine: true,
              },
            },
          ];
        }
        return [
          {
            title: 'Todos',
            filters: {},
          },
          {
            title: 'Mios',
            filters: {
              mine: true,
            },
          },
        ];
      },
      subtabs() {
        const field = this.getFieldForTotal();
        let unanswered = 0;
        let unsolved = 0;
        if (this.totals.length) {
          const noanswered = this.totals.find(item => item.status === 'Por responder');
          const nosolved = this.totals.find(item => item.status === 'Por resolver');

          unanswered = noanswered ? noanswered[field] : 0;
          unsolved = nosolved ? nosolved[field] : 0;
        }
        return [
          {
            total: unanswered,
            show: unanswered,
            title: 'Por responder',
            active: false,
            filters: {
              status: this.toRespond,
            },
          },
          {
            total: unsolved,
            show: unsolved,
            title: 'Por resolver',
            active: true,
            filters: {
              status: ['Por resolver', 'Ausente'],
            },
          },
          {
            total: 0,
            show: false,
            title: 'Resueltos',
            active: false,
            filters: {
              status: ['Resuelto'],
            },
          },
        ];
      },
      tabFilter() {
        return this.tabs[this.activeTab].filters;
      },
      subTabFilter() {
        return this.subtabs[this.activeSubTab].filters;
      },
      toRespond() {
        if (this.user.role !== 'agent' && this.activeTab !== '1') {
          return ['Por responder', 'Por asignar', 'Espera', 'Reasignado'];
        }
        return ['Por responder'];
      },
      sortedChats() {
        return this.chats
          .filter(item => this.passFilters(item) || this.activeChatId === item.id)
          .sort((a, b) => (a.last_activity > b.last_activity ? -1 : 1));
      },
      activeChat() {
        const index = this.sortedChats.findIndex(item => item.id === this.activeChatId);
        return index === -1 ? {} : this.sortedChats[index];
      },
      total() {
        return this.totals.find(item => item.status === this.status);
      },
      status() {
        return this.subTabFilter.status;
      },
      disconected() {
        return this.user.chat_center_online === 0 || this.user.chat_center_online === false;
      },
      chatCenterOnline() {
        return this.$auth.user().chat_center_online;
      },
    },
    methods: {
      init($event) {
        if ($event) {
          setTimeout(() => {
            this.fetchChats();
            this.fetchTotals();
          }, 2000);
        }
      },
      passFilters(chatCenter) {
        let flag = true;
        if (this.disconected && (this.user.role === 'agent' || this.activeTab !== '0')) {
          flag = false;
        }
        const isMine = Object.keys(this.tabFilter);
        if (isMine.length > 0 && chatCenter.user_id !== this.user.id) {
          flag = false;
        }

        if (!this.subTabFilter.status.includes(chatCenter.status)) {
          flag = false;
        }
        const filters = this.filters;
        if (filters.channels.length && !filters.channels.includes(chatCenter.channel)) {
          flag = false;
        }
        if (this.search !== '') {
          let aux = false;
          // eslint-disable-next-line
          const { user_name, internal_id, customer } = chatCenter;

          // eslint-disable-next-line
          if (user_name && user_name.toLowerCase().includes(this.search.toLowerCase())) {
            aux = true;
          }
          // eslint-disable-next-line
          if (internal_id && internal_id.toLowerCase().includes(this.search.toLowerCase())) {
            aux = true;
          }
          if (customer) {
            // eslint-disable-next-line
            const { name, first_name, last_name, account, fiscal_id } = customer;
            if (name && name.toLowerCase().includes(this.search.toLowerCase())) {
              aux = true;
            }
            // eslint-disable-next-line
            if (first_name && first_name.toLowerCase().includes(this.search.toLowerCase())) {
              aux = true;
            }
            // eslint-disable-next-line
            if (last_name && last_name.toLowerCase().includes(this.search.toLowerCase())) {
              aux = true;
            }
            // eslint-disable-next-line
            if (account && account.toLowerCase().includes(this.search.toLowerCase())) {
              aux = true;
            }
            // eslint-disable-next-line
            if (fiscal_id && fiscal_id.toLowerCase().includes(this.search.toLowerCase())) {
              aux = true;
            }
          }
          if (!aux) {
            flag = false;
          }
        }
        if (this.customFilters.minDate) {
          if (!moment(chatCenter.last_activity).isAfter(`${this.customFilters.minDate} 00:00:01`, 'minute')) {
            flag = false;
          }
        }
        if (this.customFilters.maxDate) {
          if (!moment(chatCenter.last_activity).isBefore(`${this.customFilters.maxDate} 23:59:59`, 'minute')) {
            flag = false;
          }
        }
        if (this.customFilters.solvedBy) {
          const messages = chatCenter.chat_center_messages;
          const movements = messages.filter(item => item.type !== 'message' && item.origin === 1);
          if (movements.length) {
            const lastMovement = movements[movements.length - 1];
            if (!Object.keys(lastMovement.chat_category).length) {
              flag = false;
            } else if (lastMovement.chat_category.type !== this.customFilters.solvedBy) {
              flag = false;
            }
          } else {
            flag = false;
          }
        }
        return flag;
      },
      cancelRequest() {
        this.cancelToken.cancel('');
        this.cancelToken = this.axios.CancelToken.source();
      },
      clearChatCenter() {
        this.chats = [];
        this.offset = 0;
        this.totals = [
          {
            mine: 0,
            status: 'Resuelto',
            total: 0,
          },
          {
            mine: 0,
            status: 'Por responder',
            total: 0,
          },
          {
            mine: 0,
            status: 'Por resolver',
            total: 0,
          },
        ];
        this.activeChatId = -1;
      },
      getFieldForTotal() {
        let field = 'mine';
        if (this.user.role !== 'agent') {
          field = this.activeTab === '0' ? 'total' : 'mine';
        }
        return field;
      },
      fetchTotals() {
        if (this.user.role !== 'agent' && this.activeTab === '0') {
          this.totals = [
            {
              mine: 0,
              status: 'Resuelto',
              total: 0,
            },
            {
              mine: 0,
              status: 'Por responder',
              total: 0,
            },
            {
              mine: 0,
              status: 'Por resolver',
              total: 0,
            },
          ];
        } else {
          this.cancelRequest();
          this.axios.get(this.totalUrl).then(({ data }) => {
            const index = data.total.findIndex(item => item.status === 'Ausente');
            if (index !== -1) {
              const idx = data.total.findIndex(item => item.status === 'Por resolver');
              if (idx !== -1) {
                // eslint-disable-next-line
                data.total[idx].mine += data.total[index].mine;
                // eslint-disable-next-line
                data.total[idx].total += data.total[index].total;
              } else {
                const obj = {
                  status: 'Por resolver',
                  mine: data.total[index].mine,
                  total: data.total[index].total,
                };
                data.total.push(obj);
              }
              data.total.splice(index, 1);
            }
            this.totals = data.total;
          });
        }
      },
      fetchChats(scroll = false) {
        if (!scroll) {
          this.clearChatCenter();
          this.stopScrolling = false;
        }
        if (!this.stopScrolling) {
          this.cancelRequest();
          const obj = {};
          if (this.isSearching) {
            obj.cancelToken = this.cancelToken.token;
          }
          this.isSearching = true;
          this.axios.get(this.url, obj).then((response) => {
            if (!this.offset) {
              this.chats = response.data;
            } else {
              this.chats = _.unionBy(response.data, this.chats, 'id');
            }
            if (!response.data.length || (this.chats.length && (response.data.length + this.chats.length) <= this.limit)) { // eslint-disable-line
              this.stopScrolling = true;
            } else {
              this.stopScrolling = false;
            }
            if (!this.listenEvents) {
              this.listenEvents = true;
            }
            this.isSearching = false;
          }).catch(() => {
            this.stopScrolling = false;
          });
        }
      },
      updateTotals(opt) {
        const field = this.getFieldForTotal();
        switch (opt) {
          case -1:
            if (this.total[field] > 0) {
              this.total[field] -= 1;
            }
            break;
          case 1:
            this.total[field] += 1;
            break;
          default:
            this.fetchTotals();
            break;
        }
      },
      openChat($event) {
        this.activeChatId = $event;
        if (this.activeChat.unread_messages) {
          const unread = this.activeChat.unread_messages;
          this.activeChat.unread_messages = 0;
          this.axios.patch(`chats_center/${this.activeChat.id}`, {
            unread_messages: 0,
          }).catch(() => {
            this.activeChat.unread_messages = unread;
          });
        }
        if (this.activeChat.fetch_messages) {
          this.axios.get(`chats_center/${this.activeChat.id}/messages`).then(({ data }) => {
            const index = this.sortedChats.findIndex(item => item.id === $event);
            this.sortedChats[index].chat_center_messages = data;
            this.sortedChats[index].fetch_messages = false;
          });
        }
      },
      closeChat() {
        this.activeChatId = -1;
      },
      openFiltersDrawer() {
        this.showFilters = true;
      },
      toggleChannelFilter(index) {
        this.channels[index].active = !this.channels[index].active;
      },
      filterChats() {
        this.fetchTotals();
        this.fetchChats();
        this.closeFiltersDrawer();
      },
      closeFiltersDrawer() {
        this.showFilters = false;
      },
      toggleSearchField() {
        this.showSearch = !this.showSearch;
      },
      markSolved(id) {
        const index = this.chats.findIndex(item => item.id === id);
        if (index !== -1) {
          const chatCenter = this.chats[index];
          chatCenter.status = 'Resuelto';
          if (this.activeSubTab !== '2') {
            chatCenter.disabled = true;
          }
          this.updateChatInList(index, chatCenter);
        }
      },
      updateSendedMessage($event) {
        const index = this.sortedChats.findIndex(item => item.id === $event.id);
        if (index !== -1) {
          const idx = this.sortedChats[index].chat_center_messages
            .findIndex(item => item.identifier && item.identifier === $event.identifier);
          if (idx !== -1 && Object.keys($event.chatCenterMessage).length > 0) {
            this.sortedChats[index].chat_center_messages[idx] = $event.chatCenterMessage;
          }
        }
      },
      transformChatToAppend(chatCenter) {
        const index = this.chats.findIndex(item => item.id === chatCenter.id);
        if (index !== -1) {
          this.updateChatInList(index, chatCenter);
        }
      },
      transformMessageToAppend(message) {
        const index = this.chats.findIndex(item => item.id === this.activeChat.id);
        if (index !== -1) {
          this.appendMessagesToChat(index, this.activeChat.id, message);
        }
      },
      startListeningEvents() {
        window.Echo.private(this.channel)
          .listen('.ChatCenterUpdated', (event) => {
            let chatCenter = {};
            if (event.chatCenter) {
              chatCenter = event.chatCenter;
            } else {
              chatCenter = event;
            }
            const index = this.chats.findIndex(item => item.id === chatCenter.id);
            const isAdmin = this.user.role === 'admin';
            const isMine = chatCenter.user_id === this.user.id;
            // eslint-disable-next-line
            if (((isAdmin || isMine) && this.activeTab === '0') || (((isAdmin && this.activeTab === '1') || (!isAdmin && this.activeTab === '0')) && isMine)) {
              this.changeTabsTotals(chatCenter);
            }
            if (index !== -1) {
              this.updateChatInList(index, chatCenter);
            } else {
              this.appendChatToList(chatCenter);
            }
          });
      },
      stopListeningEvents() {
        window.Echo.leave(this.channel);
        window.Echo.leave(`${this.channel}Online`);
      },
      appendChatToList(chatCenter) {
        if (this.passFilters(chatCenter)) {
          this.chats.unshift(chatCenter);
        }
      },
      updateChatInList(index, chatCenter) {
        if (this.activeChatId === -1 ||
          (this.activeChatId !== chatCenter.id && !this.passFilters(chatCenter))) {
          this.chats.splice(index, 1);
          // eslint-disable-next-line
          return;
          // eslint-disable-next-line
        } else {
          const messages = this.chats[index].chat_center_messages;
          const newMessages = _.uniqBy(messages.concat(chatCenter.chat_center_messages), 'id');
          const newItem = {
            ...this.chats[index],
            ...chatCenter,
          };
          newItem.chat_center_messages = _.orderBy(newMessages, 'created_at', 'asc');
          const passFilters = this.passFilters(newItem);
          if (!passFilters) {
            newItem.disabled = true;
          } else if (passFilters && this.chats[index].disabled) {
            newItem.disabled = false;
          }
          Vue.set(this.chats, index, newItem);
        }
      },
      appendMessagesToChat(index, chatId, messages) {
        const newItem = this.chats[index];
        const newMessages = _.orderBy(newItem.chat_center_messages.concat(messages), 'created_at', 'asc');
        newItem.chat_center_messages = newMessages;
        Vue.set(this.chats, index, newItem);
      },
      solve() {
        if (this.activeChat.status !== 'Resuelto') {
          EventBus.$emit('openSolvedDialog', this.activeChat.id);
        } else {
          EventBus.$emit('openConfirmDialog', this.activeChatId, 'unsolve');
        }
      },
      unsolve($event) {
        const index = this.chats.findIndex(item => item.id === $event.id);
        if (index !== -1) {
          this.chats[index].status = $event.status;
          if (this.activeSubTab === '2') {
            Vue.set(this.chats[index], 'disabled', true);
          }
        }
      },
      changeTabsTotals(chatCenter) {
        if (chatCenter.status_old && chatCenter.status_old !== chatCenter.status) {
          const field = this.getFieldForTotal();
          const subtab = this.subtabs[this.activeSubTab];
          const indexNew = this.totals.findIndex(item => item.status === chatCenter.status);
          const indexOld = this.totals.findIndex(item => item.status === chatCenter.status_old);
          if (subtab.filters.status === chatCenter.status && chatCenter.status !== 'Resuelto') {
            if (indexNew !== -1) {
              this.totals[indexNew][field] += 1;
            }
            if (indexOld !== -1) {
              if (this.totals[indexOld][field] > 0) {
                this.totals[indexOld][field] -= 1;
              }
            }
          } else {
            if (indexOld !== -1) {
              if (this.totals[indexOld][field] > 0) {
                this.totals[indexOld][field] -= 1;
              }
            }
            if (indexNew !== -1) {
              this.totals[indexNew][field] += 1;
            }
          }
        }
      },
      reasign($event) {
        this.selectedChat = $event;
        this.showReasignChatDialog = true;
      },
      closeReasign() {
        this.selectedChat = -1;
        this.showReasignChatDialog = false;
      },
    },
    watch: {
      disconected(newVal) {
        if (!newVal) {
          this.cancelRequest();
        } else {
          this.listenEvents = false;
        }
      },
      activeTab(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchTotals();
          this.fetchChats();
        }
      },
      activeSubTab(newVal, oldVal) {
        if (this.customFilters.solvedBy) {
          delete this.customFilters.solvedBy;
        }
        if (newVal !== oldVal) {
          this.fetchTotals();
          this.fetchChats();
        }
      },
      chats(newVal) {
        this.offset = newVal.length;
        setTimeout(() => {
          this.searchingChats = false;
        }, 500);
      },
      listenEvents(newVal) {
        if (newVal) {
          this.startListeningEvents();
        } else {
          this.stopListeningEvents();
        }
      },
      activeChat() {
        const index = this.chats.findIndex(item => item.disabled === true);
        const chat = this.chats[index];
        if (index !== -1 && chat.id !== this.activeChat.id) {
          this.chats.splice(index, 1);
        }
      },
      // eslint-disable-next-line
      search: _.debounce(function(newVal, oldVal) {
        if (newVal !== oldVal || (newVal === '' && oldVal !== '')) {
          this.cancelRequest();
          this.fetchTotals();
          this.fetchChats();
        }
      }, 1600),
      channels: {
        // eslint-disable-next-line
        handler:_.debounce(function () {
          this.cancelRequest();
          this.fetchTotals();
          this.fetchChats();
        }, 800),
        deep: true,
      },
      chatCenterOnline(newVal) {
        if (newVal === 0 || newVal === false) {
          this.cancelRequest();
          this.clearChatCenter();
        }
      },
      showSearch() {
        this.$refs.chatsList.every((item) => {
          item.updateScrollbar();
          return true;
        });
      },
    },
  };
</script>

<style scoped>
  .justify-evenly {
    justify-content: space-evenly;
  }
  .position-relative {
    position: relative;
  }
  .fill-height {
    height: calc(100vh - 55px) !important;
  }
  .fill-height.search-active {
    overflow: hidden;
  }
  .container.fill-height .layout.no-fill-height {
    height: auto;
  }
  .blured {
    filter: blur(5px);
  }
  .collapse-wrapper {
    overflow: hidden;
    transition: height 200ms;
  }
  .chat-search {
    background: #eee !important;
    margin-top: 20px;
    margin-left: 1em;
    margin-bottom: 15px;
    width: calc(100% - 2em);
  }
  #filters-button {
    top: calc(46px + 30px);
    left: 50%;
    color: #fff;
    width: calc(100% - 2em);
    margin: 0;
    z-index: 2;
    overflow: hidden;
    position: absolute;
    transform: translateX(-50%);
    max-height: 36px;
    transition: max-height 0.15s ease-out;
    font-weight: normal;
    text-transform: capitalize;
    background-color: #fff;
    background-color: #1976d2;
  }
  #filters-button.expanded {
    width: calc(25% - 45px - 2em - 2em + 8px);
    left: calc(260px + 1em - 8px);
  }
  #filters-button.hidden {
    max-height: 0;
  }
  #solved-button {
    z-index: 4;
    height: 50px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .25s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .collapse-wrapper {
    overflow: hidden;
    max-height: 80px;
    transition: max-height 0.3s ease-out; 
  }
  .collapse-wrapper.collapsed {
    max-height: 0;
  }
  .filter-active {
    top: 5px;
    right: 5px;
    color: #ff4321 !important;
    z-index: 1;
    font-size: 8px;
  }
  .badge .small {
    font-size: 10px;
  }
  .badge >>> .badge__badge.tab-badge {
    top: -14px;
    width: 18px;
    right: -14px;
    height: 18px;
  }
  .separator--right {
    border-right: 1px solid #263238!important;
  }
  .no-tabs /deep/ > .tabs__bar {
    display: none;
  }
  .tabs >>> .tab-is-active {
    /* background-color: rgba/(0, 0, 0, 0.12); */
  }
</style>



// WEBPACK FOOTER //
// src/components/chat_center/Index.vue